import React from "react";
import {
  StartWatchOption,
  useBackgroundTask,
} from "store/background-task/background-task.store";
import {
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@material-ui/core";
import {shallow} from "zustand/shallow";
import {BackgroundTaskStatus} from "ts/api/background-pubsub-task";
import {CheckCircle, ErrorOutline} from "@material-ui/icons";
import useStyles from "./styles";

const VersionModal: React.FC = () => {
  const classes = useStyles();

  const listItems = useBackgroundTask((state) => state.listItems, shallow);

  const getText = (status: BackgroundTaskStatus, options: StartWatchOption) => {
    switch (status) {
      case BackgroundTaskStatus.COMPLETED:
        return options.successText;
      case BackgroundTaskStatus.ERROR:
        return options.errorText;
      case BackgroundTaskStatus.CREATED:
        return options.inProcessText;
      default:
        return "";
    }
  };

  const renderStatus = (status: BackgroundTaskStatus) => {
    switch (status) {
      case BackgroundTaskStatus.CREATED:
        return <CircularProgress size={24} className={classes.spinner} />;
      case BackgroundTaskStatus.COMPLETED:
        return <CheckCircle className={`${classes.successIcon}`} />;
      case BackgroundTaskStatus.ERROR:
        return <ErrorOutline className={`${classes.errorIcon}`} />;
      default:
        return null;
    }
  };

  if (listItems.length) {
    return (
      <Paper className={classes.stickyBlock}>
        <List>
          {listItems.map((item, index) => (
            <ListItem key={item.commonOperationId} className={classes.listItem}>
              {renderStatus(item.status)}
              <ListItemText primary={getText(item.status, item)} />{" "}
            </ListItem>
          ))}
        </List>
      </Paper>
    );
  }

  return null;
};

export default VersionModal;
